"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.date.to-iso-string");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var logger = require("loglevel");

function prepareLine(prefix, args) {
  return ["".concat(new Date().toISOString(), " Notifications ").concat(prefix, ":")].concat(Array.from(args));
}

var Logger =
/*#__PURE__*/
function () {
  function Logger() {
    _classCallCheck(this, Logger);

    this.prefix = '';
  }

  _createClass(Logger, [{
    key: "setLevel",
    value: function setLevel(level) {
      logger.setLevel(level);
    }
  }, {
    key: "trace",
    value: function trace() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      logger.debug.apply(null, prepareLine('T' + this.prefix, args));
    }
  }, {
    key: "debug",
    value: function debug() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      logger.debug.apply(null, prepareLine('D' + this.prefix, args));
    }
  }, {
    key: "info",
    value: function info() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      logger.info.apply(null, prepareLine('I' + this.prefix, args));
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      logger.warn.apply(null, prepareLine('W' + this.prefix, args));
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      logger.error.apply(null, prepareLine('E' + this.prefix, args));
    }
  }], [{
    key: "scope",
    value: function scope() {
      var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      // TBD this.prefix += ' ' + prefix;
      return new Logger();
    }
  }]);

  return Logger;
}();

exports.Logger = Logger;
var logInstance = Logger.scope();
exports.log = logInstance;